export default {
    allNews: [],
    showNews: {},
    createdNews: {},
    deleteId: '',
    pagination: {},
    searchQuery: "&where=status@下書き,公開",
    // deletedNews: {}

}